import React, { useEffect, useState } from "react";
import "./sponsorSlider.css";

import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// IMAGE IMPORTING

import Banner1 from "../../assets/img/developed-playspots.jpg";
import Banner2 from "../../assets/img/media-one-banner.png";
import Banner3 from "../../assets/img/nadhilath-logo.png";
// import Banner4 from "../../assets/img/media-one3.jpeg";
// import Banner5 from "../../assets/img/media-one4.jpeg";
import { Link } from "react-router-dom";

const SponsorSlider = () => {
  // MOB RESPONSIVE CHANGE
  const [windowDimension, setWindowDimension] = useState(null);

  // BANNER DATA
  const [sponsorBannerData, setSponsorBannerData] = useState("");

  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    arrows: false,
    speed: 1700,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div className="sponsorSlider">
      <div className="sponsorSlider-wrapper">
        <Slider {...settings}>
          <div className="prizeSlider-wrapperImg">
            <Link to="/playspots">
              <img src={Banner1} alt="" />
            </Link>
          </div>
          <div className="prizeSlider-wrapperImg">
            <img src={Banner2} alt="" />
          </div>
           <div className="prizeSlider-wrapperImg">
            <img src={Banner3} alt="" />
          </div>
          {/*<div className="prizeSlider-wrapperImg">*/}
          {/*  <img src={Banner4} alt="" />*/}
          {/*</div>*/}
          {/*<div className="prizeSlider-wrapperImg">*/}
          {/*  <img src={Banner2} alt="" />*/}
          {/*</div>*/}
          {/*<div className="prizeSlider-wrapperImg">*/}
          {/*  <img src={Banner3} alt="" />*/}
          {/*</div>*/}
        </Slider>

        {/* <div className="sponsorSlider-wrapperImg">
          <img src={Banner1} alt="" />
        </div> */}
      </div>
    </div>
  );
};

export default SponsorSlider;
